var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingPace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_489848",
    clipPath: "url(#clip0_0_3673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.1667 5.33333H36.5V2C36.5 0.897333 35.6027 0 34.5 0H33.1667C32.064 0 31.1667 0.897333 31.1667 2V5.33333H9.83333V2C9.83333 0.897333 8.936 0 7.83333 0H6.5C5.39733 0 4.5 0.897333 4.5 2V5.33333H3.83333C1.99533 5.33333 0.5 6.82867 0.5 8.66667V36.6667C0.5 38.5047 1.99533 40 3.83333 40H37.1667C39.0047 40 40.5 38.5047 40.5 36.6667V8.66667C40.5 6.82867 39.0047 5.33333 37.1667 5.33333ZM32.5 6V2C32.5 1.632 32.7987 1.33333 33.1667 1.33333H34.5C34.868 1.33333 35.1667 1.632 35.1667 2V6V8.66667C35.1667 9.03467 34.868 9.33333 34.5 9.33333H33.1667C32.7987 9.33333 32.5 9.03467 32.5 8.66667V6ZM5.83333 6V2C5.83333 1.632 6.132 1.33333 6.5 1.33333H7.83333C8.20133 1.33333 8.5 1.632 8.5 2V6V8.66667C8.5 9.03467 8.20133 9.33333 7.83333 9.33333H6.5C6.132 9.33333 5.83333 9.03467 5.83333 8.66667V6ZM39.1667 36.6667C39.1667 37.7693 38.2693 38.6667 37.1667 38.6667H3.83333C2.73067 38.6667 1.83333 37.7693 1.83333 36.6667V17.3333H39.1667V36.6667ZM39.1667 16H1.83333V8.66667C1.83333 7.564 2.73067 6.66667 3.83333 6.66667H4.5V8.66667C4.5 9.76933 5.39733 10.6667 6.5 10.6667H7.83333C8.936 10.6667 9.83333 9.76933 9.83333 8.66667V6.66667H31.1667V8.66667C31.1667 9.76933 32.064 10.6667 33.1667 10.6667H34.5C35.6027 10.6667 36.5 9.76933 36.5 8.66667V6.66667H37.1667C38.2693 6.66667 39.1667 7.564 39.1667 8.66667V16Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.8333 8.66675H13.1667C12.798 8.66675 12.5 8.96475 12.5 9.33341V13.3334C12.5 13.7021 12.798 14.0001 13.1667 14.0001H27.8333C28.202 14.0001 28.5 13.7021 28.5 13.3334V9.33341C28.5 8.96475 28.202 8.66675 27.8333 8.66675ZM27.1667 12.6667H13.8333V10.0001H27.1667V12.6667Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.16667 19.3333H5.16667C4.798 19.3333 4.5 19.6313 4.5 19.9999V23.3333C4.5 23.7019 4.798 23.9999 5.16667 23.9999H9.16667C9.53533 23.9999 9.83333 23.7019 9.83333 23.3333V19.9999C9.83333 19.6313 9.53533 19.3333 9.16667 19.3333ZM8.5 22.6666H5.83333V20.6666H8.5V22.6666Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.8337 19.333H13.8337C13.465 19.333 13.167 19.631 13.167 19.9997V23.333C13.167 23.7017 13.465 23.9997 13.8337 23.9997H17.8337C18.2023 23.9997 18.5003 23.7017 18.5003 23.333V19.9997C18.5003 19.631 18.2023 19.333 17.8337 19.333ZM17.167 22.6663H14.5003V20.6663H17.167V22.6663Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.1667 19.3333H23.1667C22.798 19.3333 22.5 19.6313 22.5 19.9999V23.3333C22.5 23.7019 22.798 23.9999 23.1667 23.9999H27.1667C27.5353 23.9999 27.8333 23.7019 27.8333 23.3333V19.9999C27.8333 19.6313 27.5353 19.3333 27.1667 19.3333ZM26.5 22.6666H23.8333V20.6666H26.5V22.6666Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M35.8337 19.333H31.8337C31.465 19.333 31.167 19.631 31.167 19.9997V23.333C31.167 23.7017 31.465 23.9997 31.8337 23.9997H35.8337C36.2023 23.9997 36.5003 23.7017 36.5003 23.333V19.9997C36.5003 19.631 36.2023 19.333 35.8337 19.333ZM35.167 22.6663H32.5003V20.6663H35.167V22.6663Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.16667 26H5.16667C4.798 26 4.5 26.298 4.5 26.6667V30C4.5 30.3687 4.798 30.6667 5.16667 30.6667H9.16667C9.53533 30.6667 9.83333 30.3687 9.83333 30V26.6667C9.83333 26.298 9.53533 26 9.16667 26ZM8.5 29.3333H5.83333V27.3333H8.5V29.3333Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.8337 26H13.8337C13.465 26 13.167 26.298 13.167 26.6667V30C13.167 30.3687 13.465 30.6667 13.8337 30.6667H17.8337C18.2023 30.6667 18.5003 30.3687 18.5003 30V26.6667C18.5003 26.298 18.2023 26 17.8337 26ZM17.167 29.3333H14.5003V27.3333H17.167V29.3333Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M27.1667 26H23.1667C22.798 26 22.5 26.298 22.5 26.6667V30C22.5 30.3687 22.798 30.6667 23.1667 30.6667H27.1667C27.5353 30.6667 27.8333 30.3687 27.8333 30V26.6667C27.8333 26.298 27.5353 26 27.1667 26ZM26.5 29.3333H23.8333V27.3333H26.5V29.3333Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M35.8337 26H31.8337C31.465 26 31.167 26.298 31.167 26.6667V30C31.167 30.3687 31.465 30.6667 31.8337 30.6667H35.8337C36.2023 30.6667 36.5003 30.3687 36.5003 30V26.6667C36.5003 26.298 36.2023 26 35.8337 26ZM35.167 29.3333H32.5003V27.3333H35.167V29.3333Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M9.16667 32.6667H5.16667C4.798 32.6667 4.5 32.9647 4.5 33.3334V36.6667C4.5 37.0354 4.798 37.3334 5.16667 37.3334H9.16667C9.53533 37.3334 9.83333 37.0354 9.83333 36.6667V33.3334C9.83333 32.9647 9.53533 32.6667 9.16667 32.6667ZM8.5 36.0001H5.83333V34.0001H8.5V36.0001Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.8337 32.667H13.8337C13.465 32.667 13.167 32.965 13.167 33.3337V36.667C13.167 37.0357 13.465 37.3337 13.8337 37.3337H17.8337C18.2023 37.3337 18.5003 37.0357 18.5003 36.667V33.3337C18.5003 32.965 18.2023 32.667 17.8337 32.667ZM17.167 36.0003H14.5003V34.0003H17.167V36.0003Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M27.321 32.2402L24.455 35.6796L22.971 34.1956L22.0283 35.1382L24.0283 37.1382C24.153 37.2642 24.323 37.3336 24.4997 37.3336C24.5097 37.3336 24.5197 37.3336 24.5297 37.3329C24.717 37.3242 24.8917 37.2376 25.0123 37.0942L28.3457 33.0942L27.321 32.2402Z",
    fill: "#111111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M35.321 32.2402L32.455 35.6796L30.971 34.1956L30.0283 35.1382L32.0283 37.1382C32.153 37.2642 32.323 37.3336 32.4997 37.3336C32.5097 37.3336 32.5197 37.3336 32.5297 37.3329C32.717 37.3242 32.8917 37.2376 33.0123 37.0942L36.3457 33.0942L35.321 32.2402Z",
    fill: "#111111"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingPace);
export default __webpack_public_path__ + "static/media/booking-pace.ae93cc779bb57fba1d3ee9ce3c6d9653.svg";
export { ForwardRef as ReactComponent };